<template>
  <div class="container-fluid">

    <!-- <spreadsheet ref="spreadsheet"
                :excel-proxy-URL="'https://demos.telerik.com/kendo-ui/service/export'"
                :pdf-proxy-URL="'https://demos.telerik.com/kendo-ui/service/export'">
        <spreadsheet-sheet :name="'Food Order'"
                            :merged-cells="mergedCells"
                            :rows="firstRows"
                            :columns="firstColumns">
        </spreadsheet-sheet>
    </spreadsheet> -->

    <div class="row" v-if="rdy">
      <!-- style="overflow: auto; max-height: calc(100vh - 80px);" -->
      <div class="col-2" v-if="mode == 0" v-show="!printable" >
        <main>
          <nav
            :class="`${getQuestionColor(q)}`"
            v-for="(q, i) in filled.form.questions"
            :key="i"
          >
            {{ i + 1 }}
          </nav>
        </main>
        <button v-if="hasPerr(['exam_mark_reveiw'])" @click="resultFinishFlag()" class="mg-t-20 btn btn-info btn-sm">
          Дүн хянаж дууссан
        </button>
        <a
          :href="`/#/examPrintByPerson/${id}/${userId}`"
          class="mg-l-10 mg-t-20 btn btn-primary btn-sm"
          target="_blank"
        >
          <feather type="printer"></feather>
          Хэвлэх
        </a>

        <div class="mg-t-20">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Асуулт</th>
                <th>Авсан</th>
                <th>Авах оноо</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(s, ssi) in filled.form.sections" >
                <tr>
                  <td colspan="3">{{ romanize(ssi + 1) }}. {{ s.name }}</td>
                </tr>
                <tr v-for="(q, qqi) in filled.form.questions.filter((x) => x.sId == s.id)" :key="`${ssi}_${qqi}`">
                  <td>№: {{qqi+1 }}</td>
                  <td :class="`text-right ${q.avsan>0?'':'text-muted'}`">{{ q.avsan }}</td>
                  <td class="text-right">{{ q.avah }}</td>
                </tr>
              </template>
              <tr>
                <td colspan="2" class="text-right">Нийт : {{ 

                  (filled.form.questions.reduce((sum, st) => sum + parseFloat(st.avsan), 0)*100/
                  filled.form.questions.reduce((sum, st) => sum + parseFloat(st.avah), 0)).toFixed(2)
                 }}%</td>
                <td>{{ filled.form.questions.reduce((sum, st) => sum + parseFloat(st.avsan), 0) }}/
                  {{ filled.form.questions.reduce((sum, st) => sum + parseFloat(st.avah), 0) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- style="overflow: auto; max-height: calc(100vh - 80px);" -->
      <div ref="scrollableDiv" :class="`col-${mode == 0 && !printable ? '10' : '12'}`" >
        <div v-for="(s, si) in filled.form.sections" :key="si">
          <div
            class="text-white d-flex align-items-center bd-y bg-primary pd-y-5 mg-t-10 mg-b-10 pd-x-10 bd-primary"
            style="border-radius: 10px 10px 0 0;"
          >
            <div class="mg-r-5">{{ romanize(si + 1) }}.</div>
            <h6 class="text-white tx-uppercase tx-semibold mg-b-0">
              {{ s.name }}
            </h6>
          </div>

          <div
            v-for="(q, i) in filled.form.questions.filter((x) => x.sId == s.id)"
            :key="i"
            class="unselectable"
          >
            <div class="bd-b d-flex align-items-center pd-x-10 tx-semibold">
              <div class="mg-r-5">{{ i + 1 }}).</div>
              <div
                v-if="q.t == 31"
                v-html="generateMissingWords(q)"
                class="pd-y-5"
              ></div>
              <div v-else v-html="q.q" class></div>
            </div>
            <div v-if="q.t == 1 || q.t == 11" class="mg-x-20 mg-y-10 pd-10 bd">
              <div v-if="canViewResult == 2">
                Хэрэглэгч хариулсан нь: {{ q.as[0].s }}
              </div>
              <div v-else class="d-flex">
                <div class="wd-50p">
                  <span class="d-block tx-11 text-muted"
                    >Хэрэглэгч хариулсан нь</span
                  >
                  <h6
                    class="tx-13 tx-inverse tx-semibold mg-b-0"
                    style="word-break: break-all;"
                  >
                    {{ q.as[0].s }}
                  </h6>
                </div>
                <div class="wd-50p" v-if="canViewResult != 2">
                  <span class="d-block tx-11 text-muted"
                    >Харгалзах утга нь</span
                  >
                  <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                    {{ q.mainMatchValue }}
                  </h6>
                </div>
              </div>
              <div
                class="mg-t-10 d-flex align-items-center pd-t-5"
                v-if="mode == 0"
              >
                <div class="mg-r-10">Оноо өгөх:</div>
                <div class="mg-x-5 text-muted">{{ q.mainMassValue }}-c</div>
                <div class="input-group wd-300">
                  <input
                    v-model="q.point"
                    type="text"
                    class="form-control"
                    placeholder="Оноогоо оруулна уу"
                  />
                  <div class="input-group-append">
                    <button
                      @click="saveExamQuestionPoint(q)"
                      class="btn btn-outline-light"
                      type="button"
                    >
                      Хадгалах
                    </button>
                  </div>
                </div>
                <div class="mg-l-auto">
                  Харгалзах утга
                  {{
                    q.mainMatchValue == q.as[0].s &&
                    q.as[0].s != null &&
                    q.as[0].s.length > 0
                      ? "таарсан"
                      : "зөрсөн"
                  }}
                </div>
              </div>
            </div>
            <div v-else-if="q.t == 7 || q.t == 21" class="mg-l-20 pd-y-10">
              <div v-if="canViewResult == 2">
                Хэрэглэгч хариулсан нь:
                {{ formatNumeral(q.as[0].s) }}
              </div>
              <div
                v-else
                :class="`alert alert-${getAnswerColor(q, q.as[0])} mg-b-0`"
                role="alert"
              >
                <h6 class="alert-heading" v-if="q.as[0].if && q.as[0].isTrue">
                  Зөв хариулсан!
                </h6>
                <h6
                  class="alert-heading"
                  v-else-if="q.as[0].if && !q.as[0].isTrue"
                >
                  Буруу хариулсан!
                </h6>
                <h6 class="alert-heading" v-else-if="!q.as[0].if">
                  Огт хариулаагүй!
                </h6>
                <p class="mb-0" v-if="q.t == 7">
                  Хэрэглэгч хариулсан нь: {{ formatNumeral(q.as[0].s) }}
                </p>
                <p class="mb-0" v-if="q.t == 21">
                  Хэрэглэгч хариулсан нь:
                  {{ formatNumeral(q.as[0].s) }}
                  <span class="mg-l-5 text-muted">{{ q.tp }}</span>
                </p>
                <hr class="mg-y-5" />
                <p class="mb-0">
                  Харгалзах утга нь: {{ formatNumeral(q.mainMatchValue) }}
                  <span v-if="q.t == 21" class="mg-l-5 text-muted">{{
                    q.tp
                  }}</span>
                </p>
              </div>
            </div>
            <!-- <div v-else-if="q.t==21" class="mg-l-20 pd-y-10">
                                {{q.as[0].s | formatMoney(2,'.',',')}}<span class="mg-l-5 text-muted">{{q.tp}}</span>
                </div>-->
            <div v-else-if="q.t == 22" class="mg-l-20 pd-y-10">
              <div v-if="canViewResult == 2">
                Хэрэглэгч хариулсан нь: {{ q.as[0].s }}
              </div>
              <div
                v-else
                :class="`alert alert-${getAnswerColor(q, q.as[0])} mg-b-0`"
                role="alert"
              >
                <h6 class="alert-heading" v-if="q.as[0].if && q.as[0].isTrue">
                  Зөв хариулсан!
                </h6>
                <h6
                  class="alert-heading"
                  v-else-if="q.as[0].if && !q.as[0].isTrue"
                >
                  Буруу хариулсан!
                </h6>
                <h6 class="alert-heading" v-else-if="!q.as[0].if">
                  Огт хариулаагүй!
                </h6>
                <p class="mb-0">Хэрэглэгч хариулсан нь: {{ q.as[0].s }}</p>
                <hr class="mg-y-5" />
                <p class="mb-0">Харгалзах утга нь: {{ q.mainMatchValue }}</p>
              </div>
            </div>
            <div
              v-else-if="q.t == 3 || q.t == 4 || q.t == 23 || q.t == 24"
              v-for="(a, ai) in q.as"
              :key="ai"
              class="mg-l-20"
            >
              <div :class="`d-flex text-${getAnswerColor(q, a)}`">
                <div class="mg-r-10 tx-16">
                  <i :class="`far fa-${getAnswerIcon(q, a)}`"></i>
                </div>
                <div class="mg-r-5">{{ alphabetize(ai) }}).</div>
                <div v-html="a.a"></div>
                <!-- {{a.isTrue}} -->
              </div>

              <div
                v-if="a.if && q.t == 23"
                class="bg-gray-100 pd-10 mg-b-20 bd-5 bd-l bd-secondary"
              >
                <div class="mg-l-10 mg-b-5">
                  тайлбар:
                  <feather type="message-square" class="pd-r-5"></feather
                  >{{ q.matchValue }}
                </div>
                <div class="d-flex align-items-center mg-l-10" v-if="mode == 0">
                  <div class="mg-r-10">Оноо өгөх:</div>
                  <div class="mg-x-5 text-muted">{{ q.mainMassValue }}-c</div>
                  <div class="input-group wd-300">
                    <input
                      v-model="q.point"
                      type="text"
                      class="form-control input-sm"
                      placeholder="Оноогоо оруулна уу"
                    />
                    <div class="input-group-append">
                      <button
                        @click="saveExamQuestionPoint(q)"
                        class="btn btn-outline-light"
                        type="button"
                      >
                        Хадгалах
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="q.t == 32 || q.t == 33" class="mg-l-20 pd-y-10">
              <div class="row">
                <div class="col-6">
                  <h6
                    class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
                  >
                    Хэрэглэгч хариулсан
                  </h6>
                  <ul class="list-group">
                    <li
                      v-for="(a, i) in sortedAnswers(q, 'fillingOrd')"
                      :key="i"
                      class="list-group-item d-flex align-items-center"
                    >
                      <div>{{ i + 1 }}.</div>
                      <div
                        :class="
                          `mg-l-10 bg-${getAnswerColor(
                            q,
                            a
                          )} text-white pd-y-5 pd-x-10 bd rounded`
                        "
                      >
                        {{ a.a }}
                      </div>
                      <!-- <feather v-if="a.isTrue" type="x" class="mg-l-auto"></feather> -->
                      <span class="mg-l-auto">{{ a.fillingOrd }}</span>
                    </li>
                  </ul>
                </div>
                <div class="col-6" v-if="canViewResult != 2">
                  <h6
                    class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
                  >
                    Зөв дараалал
                  </h6>
                  <ul class="list-group">
                    <li
                      v-for="(a, i) in sortedAnswers(q, 'ord')"
                      :key="i"
                      class="list-group-item d-flex align-items-center"
                    >
                      <div>{{ i + 1 }}.</div>
                      <div
                        class="bg-gray-100 rounded mg-l-10 pd-y-5 pd-x-10 bd"
                      >
                        {{ a.a }}
                      </div>
                      <!-- <feather v-if="a.isTrue" type="x" class="mg-l-auto"></feather> -->
                      <span class="mg-l-auto">{{ a.ord }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div v-else-if="q.t == 34 && q.as.length == 8">
              <div class="row">
                <div class="col-6">
                  <h6
                    class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
                  >
                    Хэрэглэгч хариулсан
                  </h6>
                  <div class="wd-500" style="width: 510px;">
                    <div class="row no-gutters square-group-loop-outer">
                      <div
                        class="col-6"
                        style="height: 210px;"
                        v-for="(gl, gli) in 4"
                        :key="gli"
                      >
                        <div>
                          <div
                            class="rounded sction pos-absolute wd-250 ht-200"
                            style="overflow:hidden"
                          >
                            <div
                              class="cmbo pos-absolute bd pd-20 ht-150 wd-200"
                            >
                              <div
                                class="dd pos-absolute"
                                v-if="canViewResult == 2"
                              >
                                <span class="badge">{{
                                  q.as.filter((x) => x.ord != 0)[gli].a
                                }}</span>
                              </div>
                              <div
                                class="dd pos-absolute"
                                v-else-if="
                                  q.as.filter(
                                    (x) => x.ord != 0 && x.gg == gli + 1
                                  ).length &&
                                    q.as.filter(
                                      (x) => x.ord != 0 && x.gg == gli + 1
                                    )[0].g ==
                                      q.as.filter(
                                        (x) => x.ord != 0 && x.gg == gli + 1
                                      )[0].gg
                                "
                              >
                                {{
                                  q.as.filter(
                                    (x) => x.ord != 0 && x.gg == gli + 1
                                  )[0].a
                                }}
                                <span class="badge badge-success">{{
                                  q.as.filter((x) => x.ord != 0)[gli].a
                                }}</span>
                              </div>
                              <div
                                class="dd pos-absolute"
                                v-else-if="
                                  q.as.filter(
                                    (x) => x.ord != 0 && x.gg == gli + 1
                                  ).length &&
                                    q.as.filter(
                                      (x) => x.ord != 0 && x.gg == gli + 1
                                    )[0].g !=
                                      q.as.filter(
                                        (x) => x.ord != 0 && x.gg == gli + 1
                                      )[0].gg
                                "
                              >
                                <span class="badge badge-danger">{{
                                  q.as.filter(
                                    (x) => x.ord != 0 && x.gg == gli + 1
                                  )[0].a
                                }}</span>
                                (
                                <span class="badge badge-success">{{
                                  q.as.filter((x) => x.ord != 0)[gli].a
                                }}</span>
                                )
                              </div>
                              <div class="dd pos-absolute" v-else>
                                <span class="badge badge-warning">{{
                                  q.as.filter((x) => x.ord != 0)[gli].a
                                }}</span>
                              </div>
                            </div>
                            <div
                              class="dugui pos-absolute wd-300 ht-300 rounded-circle bd"
                            >
                              <div class="wd-150 txt pd-10">
                                {{ q.as.filter((x) => x.ord == 0)[gli].a }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6" v-if="canViewResult != 2">
                  <h6
                    class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
                  >
                    Зөв хариу
                  </h6>
                  <div class="wd-500" style="width: 510px;">
                    <div class="row no-gutters square-group-loop-outer">
                      <div
                        class="col-6"
                        style="height: 210px;"
                        v-for="(gl, gli) in 4"
                        :key="gli"
                      >
                        <div>
                          <div
                            class="rounded sction pos-absolute wd-250 ht-200"
                            style="overflow:hidden"
                          >
                            <div
                              class="cmbo pos-absolute bd pd-20 ht-150 wd-200"
                            >
                              <span class="dd pos-absolute">{{
                                q.as.filter((x) => x.ord != 0)[gli].a
                              }}</span>
                            </div>
                            <div
                              class="dugui pos-absolute wd-300 ht-300 rounded-circle bd"
                            >
                              <div class="wd-150 txt pd-10">
                                {{ q.as.filter((x) => x.ord == 0)[gli].a }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="q.t == 41" class="bg-gray-100 mg-l-20 mg-b-20 pd-10">
              <div v-for="(a, ai) in q.as.filter(a=>a.a!=null)" :key="`a_${ai}`">
                <!-- spreadsheet_{{a.aId}} -->
                <div class="">
                  <div :style="`visibility: ${canViewResult == 2? 'hidden':'visible'}; height: ${canViewResult == 2? '0':'auto'}`">
                    <h6 class="mg-t-20">Зөв хариулт</h6>
                    <spreadsheet 
                      :ref="`spreadsheet_shoblom_${a.aId}`"
                      :toolbar="false"
                      :sheetsbar="false"
                    >
                    </spreadsheet>
                  </div>
                  <h6 class="mg-t-20">Хэрэглэгч хариулсан нь</h6>
                  <spreadsheet
                    :ref="`spreadsheet_${a.aId}`"
                    :toolbar="false"
                    :sheetsbar="false"
                  >
                  </spreadsheet>
                </div>
                
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral';

import { request } from "@/api/all";
import { romanize, alphabetize, hasOneOf } from "@/libs/tools";
import { MessageBox } from "element-ui";

import "@progress/kendo-ui";
import "@/kendo-ui-license.js";
import "@progress/kendo-theme-default/dist/all.css";
import { Spreadsheet, SpreadsheetSheet } from "@progress/kendo-spreadsheet-vue-wrapper";

export default {
  components: {
    spreadsheet: Spreadsheet,
    "spreadsheet-sheet": SpreadsheetSheet,
  },
  props: {
    id: {
      type: Number,
      default: () => null,
    },
    cid: {
      type: Number,
      default: () => null,
    },
    userId: {
      type: String,
      default: () => "",
    },
    mode: {
      type: Number,
      default: () => 0,
    },
    printable: {
      type: Boolean,
      default: () => false,
    },
    printMode: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      rdy: false,
      filled: {
        form: {},
      },
      canViewResult: 0,
    };
  },
  mounted() {
    if (this.id > 0) {
      this.init();
    }
  },
  computed: {
    courseId() {
      return this.id;
    },
  },
  watch: {
    courseId(val) {
      if (val > 0) {
        this.init();
      }
    },
  },
  methods: {
    formatNumeral(v){
      try{
        return numeral(v).format('0,0');
      }catch(ex){
        return v;
      }
    },
    hasPerr(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    saveExamQuestionPoint(q) {
      //console.log('step 1', q);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Form/SetExamQuestionPoint" },
        data: {
          courseId: this.cid,
          responseId: q.responseId,
          point: q.point,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.init();
        }
      });
    },
    init() {
      //console.log('init fired', this.id);
      this.toggleBodyClass("addClass", "dynamic-locker");
      let _url = "v2/Form/ExamFilledData";
      let _data = {
        id: this.id,
        userId: this.userId,
      };
      if (this.mode == 1) {
        _url = "V2/Form/LessonExamFilledData";
        _data = { id: this.id };
      }
      request({
        api: { method: "POST", url: _url },
        data: _data,
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log('ExamFilledData=> ', res, this.mode);
        if (res != false) {
          this.filled.form = res.data.form;
          this.$emit('on-result-loaded', res.data);
          this.$emit('on-result-loaded2024', res.data.perc);
          if (this.mode == 1) {
            this.canViewResult = res.data.result.canViewResult;
          }
          if (this.printable == true) this.canViewResult = 2;
          this.rdy = true;
          //this.filled.sidebar = true;
          this.$nextTick(()=>{
            this.filledAfter();  
          });
        }
      });
    },
    filledAfter(){
      let increaseIndex= 0;
      this.filled.form.questions.filter(q=>q.t==41).forEach((q) => {
        // console.log('q as', q.as);
        increaseIndex++;
        q.as.filter(a=>a.a!=null).forEach((a, aind) => {
          // console.log('as n a', a);
          // console.log(aind)
          const _ss= JSON.parse(a.shablom);
          const _aa= JSON.parse(a.a);
          var spreadsheet_shoblom = this.$refs[`spreadsheet_shoblom_${a.aId}`][0].kendoWidget();
          var spreadsheet = this.$refs[`spreadsheet_${a.aId}`][0].kendoWidget();

          let _h = 90;
          if(_aa.sheets.length){
            // console.log('step 1');
            if(_aa.sheets[0]['rows'].length){
              // console.log('-----------------------------step 2', _aa.sheets.length);
              _aa.sheets[0]['rows'].forEach((c)=>{
                // console.log('c height', c.height, _aa)
                if(c.height!=undefined){
                  _h+= c.height;
                }else if(_aa.rowHeight!=undefined){
                  _h+= _aa.rowHeight;
                }else{
                  _h+= 15;
                }
              });
              // console.log('2', _aa.sheets[0]['rows']);
            }
          }
          _h=_h+20;

          // console.log('h for ',_h, q.qId)
          
          spreadsheet.element.css("height", `${_h}px`);
          spreadsheet.element.css("width", "100%");
          
          spreadsheet.fromJSON(_aa);
          spreadsheet.resize();

          spreadsheet_shoblom.element.css("height", `${_h}px`);
          spreadsheet_shoblom.element.css("width", "100%");
          
          spreadsheet_shoblom.fromJSON(_ss);
          spreadsheet_shoblom.resize();
          
          const sheet = spreadsheet.activeSheet();
          if (a.g != 0 && a.o != 0) sheet.resize(a.o+1, a.g+1);

          const sheet_shoblom = spreadsheet_shoblom.activeSheet();
          if (a.g != 0 && a.o != 0) sheet_shoblom.resize(a.o+1, a.g+1);

          for (var i = 97; i <= 122; i++) {
              var char = String.fromCharCode(i);
              [`${char}1:99`].forEach((x)=>{
                // console.log('x', x, this.$refs[`spreadsheet_${a.aId}`][0].kendoWidget().activeSheet());
                var range = this.$refs[`spreadsheet_${a.aId}`][0].kendoWidget().activeSheet().range(x);
                range.enable(false);
                var rangeS = this.$refs[`spreadsheet_shoblom_${a.aId}`][0].kendoWidget().activeSheet().range(x);
                rangeS.enable(false);
              });
          }
          

          // console.log('aind', aind);
        });

        // console.log('increaseIndex', increaseIndex);
        if(this.filled.form.questions.filter(q=>q.t==41).length==increaseIndex){
          this.$nextTick(()=>{
            const divElement = this.$refs.scrollableDiv;
            divElement.scrollTop = 0;
            
          });
        }
      });
      // console.log('this.filled.form', this.filled.form);
    },
    getAnswerIcon(q, a) {
      let rv = "";
      if (this.canViewResult == 2) {
        if (a.if) rv = "edit";
        else rv = "square";
      } else {
        if (q.t == 3) {
          if (a.if && a.isTrue) {
            rv = "check-square";
          } else if (!a.if && a.isTrue) {
            rv = "check-square";
          } else if (a.if && !a.isTrue) {
            rv = "minus-square";
          } else {
            rv = "square";
          }
        } else if (q.t == 4) {
          if (a.if && a.isTrue) rv = "check-circle";
          else if (!a.if && a.isTrue) rv = "check-circle";
          else if (a.if && !a.isTrue) rv = "times-circle";
          else rv = "circle";
        } else if (q.t == 23) {
          if (a.if) rv = "check-circle";
          else rv = "circle";
        } else if (q.t == 24) {
          if (a.if && a.isTrue) rv = "check-circle";
          else if (!a.if && a.isTrue) rv = "check-circle";
          else if (a.if && !a.isTrue) rv = "times-circle";
          else rv = "circle";
        }
      }
      return rv;
    },
    getAnswerColor(q, a) {
      let rv = "";
      if (this.canViewResult == 2) {
        rv = "gray-400";
      } else {
        if (q.t == 3 || q.t == 4) {
          if (!q.isFilled && a.isTrue) {
            rv = "warning";
          } else if (q.isFilled && a.isTrue && !a.if) {
            rv = "primary";
          } else if (a.if && a.isTrue) {
            rv = "success";
          } else if (!a.if && a.isTrue) {
            rv = "success";
          } else if (a.if && !a.isTrue) {
            rv = "danger";
          }
        } else if (q.t == 7 || q.t == 21) {
          if (a.if && a.isTrue) {
            rv = "success";
          } else if (a.if && !a.isTrue) {
            rv = "danger";
          } else if (!a.if) {
            rv = "warning";
          }
        } else if (q.t == 22) {
          if (a.if && a.isTrue) {
            rv = "success";
          } else if (a.if && !a.isTrue) {
            rv = "danger";
          } else if (!a.if) {
            rv = "warning";
          }
        } else if (q.t == 24) {
          if (a.if && a.isTrue) {
            rv = "success";
          } else if (a.if && !a.isTrue) {
            rv = "danger";
          } else if (!a.if && a.isTrue && !q.isFilled) {
            rv = "warning";
          }
        } else if (q.t == 32 || q.t == 33) {
          if (a.if && a.ord == a.fillingOrd) {
            rv = "success";
          } else if (a.if && a.ord != a.fillingOrd) {
            rv = "danger";
          } else if (a.fillingOrd == null || a.fillingOrd == "") {
            rv = "warning";
          }
        }
      }
      return rv;
    },
    getQuestionColor(q) {
      let rv = "";
      if (q.isFilled) {
        rv = "bg-primary text-white";
        // if ((q.t == 1 || q.t == 11) && q.point > 0) {
        //   rv = "bg-success text-white";
        // }else if ((q.t == 32 || q.t == 33 || q.t == 34)) {
        //   if(q.mainMassValue==100){
        //     rv = "bg-success text-white";
        //   }else{
        //     rv = "bg-danger text-white";
        //   }
        // } else if (q.as.filter(x => x.if && x.isTrue).length) {
        //   rv = "bg-success text-white";
        // } else if (q.as.filter(x => !x.if && x.isTrue).length) {
        //   rv = "bg-danger text-white";
        // }
      } else {
        rv = "bg-warning text-white";
      }
      return rv;
    },
    romanize(v) {
      return romanize(v);
    },
    alphabetize(v) {
      return alphabetize(v);
    },
    generateMissingWords(q) {
      let rv = q.q;
      for (let k = 1; k <= q.answerGroupCount; k++) {
        let at = q.as.filter((x) => x.g == k);
        let bldr = ``;
        if (at.length) {
          if (this.canViewResult == 2) {
            if (at.filter((x) => x["if"] == true).length) {
              bldr = `<span class="badge">${
                at.filter((x) => x["if"] == true)[0].a
              }</span>`;
            }
          } else {
            if (
              at.filter((x) => x["if"] == true && x["isTrue"] == true).length
            ) {
              bldr = `<span class="badge badge-success">${
                at.filter((x) => x["isTrue"] == true)[0].a
              }</span>`;
            } else if (
              at.filter((x) => x["if"] == true && x["isTrue"] != true).length
            ) {
              bldr = `<span class="badge badge-danger">${
                at.filter((x) => x["if"] == true)[0].a
              }</span>`;
              bldr += ` ( <span class="badge badge-success">${
                at.filter((x) => x["isTrue"] == true)[0].a
              }</span> )`;
            } else if (at.filter((x) => x["isTrue"] == true).length) {
              bldr = `<span class="badge badge-warning">${
                at.filter((x) => x["isTrue"] == true)[0].a
              }</span>`;
            }
          }
        }

        rv = rv.replace("{" + k + "}", bldr);
      }
      //console.log(q);
      return rv;
    },
    sortedAnswers(q, ord) {
      let rv = [];
      rv = _.orderBy(q.as, [ord], ["asc"]);
      return rv;
    },
    // printMode(){
    //   this.$router.push({
    //                 name: "examPrintByPerson",
    //                 params: {
    //                   id: this.id,
    //                   userId: this.userId,
    //                 }
    //               });
    // },
    resultFinishFlag() {
      MessageBox.confirm("Дүн хянаж дууссан уу?", "Үйлдлийг буцаах боломжгүй", {
        confirmButtonText: "Тийм",
        cancelButtonText: "Үгүй",
        callback: (action) => {
          if (action == "cancel") {
          } else if (action == "confirm") {
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "POST", url: "v2/Form/SetResultFinishFlag" },
              data: {
                courseId: this.cid,
                resultId: this.filled.form.resultId,
              },
              store: this.$store,
            }).then((res) => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (res != false) {
                this.init();
                this.$bvToast.toast("Дүн заслаа", {
                  title: "Амжилттай",
                  autoHideDelay: 500,
                  appendToast: false,
                });
                this.$emit("res-finished");
              }
            });
          }
        },
      });
    },
  },
};
</script>

<style></style>
